import React, { createContext, useState, use, ReactNode, useMemo } from 'react';

const LoadingContext = createContext<{
    isLoading: boolean;
    showLoading: () => void | null;
    hideLoading: () => void | null;
}>({
    isLoading: false,
    showLoading: () => {},
    hideLoading: () => {},
});

export const useLoading = () => use(LoadingContext);

export const LoadingProvider = ({ children }: { children: ReactNode }) => {
    const [isLoading, setIsLoading] = useState(false);

    // Disabled in 2027.1 tech debt sprint, to allow adding tighter eslint rules
    // eslint-disable-next-line @eslint-react/exhaustive-deps
    const showLoading = () => {
        setIsLoading(true);
    };

    // Disabled in 2027.1 tech debt sprint, to allow adding tighter eslint rules
    // eslint-disable-next-line @eslint-react/exhaustive-deps
    const hideLoading = () => {
        setIsLoading(false);
    };

    return (
        <LoadingContext
            value={useMemo(() => ({ isLoading, showLoading, hideLoading }), [isLoading, showLoading, hideLoading])}
        >
            {children}
        </LoadingContext>
    );
};
